var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rai-wigo box"},_vm._l((_vm.wigos),function(wigo,index){return _c('wigo-chip',{key:`wigo-${index}`,staticClass:"mr-2",attrs:{"wigo":wigo,"outlined":_vm.wigoSelected !== wigo,"link":"","show-details":_vm.showDetails},on:{"click":function($event){return _vm.selectWigo(wigo)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }